import React, { useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import clsx from 'clsx';
import styles from './styles.module.scss';
import EmptyImageIcon from 'assets/iconComponents/EmptyImageIcon';

const ImageWithLoader = ({ src, emptyLabel, classNames, ...props }) => {
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(null);

    const renderContent = () => {
        if (!src || error) return (
            <Box className={clsx(classNames?.empty)}>
                <EmptyImageIcon />
                {emptyLabel}
            </Box>
        );

        return (
            <Box className={styles.imageContainer}>
                {!loaded && (
                    <>
                        <CircularProgress
                            size={32}
                            className={styles.loader}
                        />
                        <Box
                            component="img"
                            src={src}
                            onLoad={() => setLoaded(true)}
                            onError={() => setError(true)}
                            className={styles.hidden}
                        />
                    </>
                )
                }
                {loaded &&
                    <Box
                        component="img"
                        src={src}
                        onLoad={() => setLoaded(true)}
                        className={styles.image}
                    />
                }
            </Box>

        );
    }

    return (
        <Box
            className={clsx(styles.mainContainer, classNames?.main)}
            {...props}
        >
            {renderContent()}
        </Box>
    );
}

export default ImageWithLoader;
